import { Form, Formik, FormikProps } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';
import { IInviteOverview, UserNameable } from '../../../../lib/types';
import { FormActionsRow } from '../../../_core/form/input/form-actions-row';

interface IEditInviteFormFieldProps {
  givenName: string;
  familyName: string;
}

interface IEditInviteFormProps extends IRIFormProps<UserNameable> {
  invite: IInviteOverview;
}

export const EditInviteForm = ({ invite, onBack, onSubmit }: IEditInviteFormProps) => {
  return (
    <Formik
      initialValues={{ givenName: invite.givenName ?? '', familyName: invite.familyName ?? '' }}
      onSubmit={({ givenName, familyName }) => onSubmit({ givenName: givenName.trim(), familyName: familyName.trim() })}
    >
      {(props: FormikProps<IEditInviteFormFieldProps>) => (
        <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
          <FormInputWithLabel name="givenName" label="First Name" placeholder="Edit first name" />
          <FormInputWithLabel name="familyName" label="Last Name" placeholder="Edit last name" />
          <FormActionsRow>
            {!!onBack && <FormButton onPress={onBack} text="Cancel" type="button" variant="secondary" />}
            <FormButton loading={props.isSubmitting} text="Update" />
          </FormActionsRow>
        </Form>
      )}
    </Formik>
  );
};
